import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Alert } from "react-bootstrap";
import { useAuth } from "../contexts/AuthContext";
import { useI18n } from "../i18n";

interface ProfileModalProps {
  show: boolean;
  onHide: () => void;
}

const ProfileModal: React.FC<ProfileModalProps> = ({ show, onHide }) => {
  const { user, updateProfile } = useAuth();
  const { t } = useI18n();
  const [telegramChatId, setTelegramChatId] = useState("");
  const [message, setMessage] = useState<{
    type: "success" | "danger";
    text: string;
  } | null>(null);

  useEffect(() => {
    if (user) {
      setTelegramChatId(user.telegram_chat_id || "");
    }
  }, [user]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      await updateProfile(telegramChatId);
      setMessage({ type: "success", text: t("profile.updatedSuccess") });
      setTimeout(() => {
        onHide();
        setMessage(null);
      }, 1500);
    } catch (error) {
      setMessage({ type: "danger", text: t("profile.updateError") });
    }
  };

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>
          <i className="bi bi-gear"></i> {t("profile.title")}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {message && (
          <Alert
            variant={message.type}
            dismissible
            onClose={() => setMessage(null)}
          >
            {message.text}
          </Alert>
        )}
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>{t("common.username")}</Form.Label>
            <Form.Control type="text" value={user?.username || ""} readOnly />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>{t("common.email")}</Form.Label>
            <Form.Control type="email" value={user?.email || ""} readOnly />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>{t("profile.telegramLabel")}</Form.Label>
            <Form.Control
              type="text"
              placeholder={t("profile.telegramPlaceholder")}
              value={telegramChatId}
              onChange={(e) => setTelegramChatId(e.target.value)}
            />
            <Form.Text className="text-muted">
              {t("profile.telegramHelpText")} <a
                href="https://t.me/userinfobot"
                target="_blank"
                rel="noopener noreferrer"
              >
                @userinfobot
              </a>
            </Form.Text>
          </Form.Group>

          <Button variant="primary" type="submit" className="w-100">
            <i className="bi bi-save"></i> {t("profile.saveSettings")}
          </Button>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default ProfileModal;
